import React from 'react';

// Portal components
import { ProtectedRoute } from '../components/auth/ProtectedRoute';
import { PortalLayoutWithFeatures as PortalLayout } from '../components/portal/PortalLayoutWithFeatures';

interface RouteConfig {
  path: string;
  element: React.ReactNode;
}

export const portalRoutes: RouteConfig[] = [
  {
    path: "/portal/*",
    element: (
      <ProtectedRoute>
        <PortalLayout />
      </ProtectedRoute>
    ),
  },
];
